import { useState } from 'react';
import GroupHealthSettingsModal from './group-health-settings-modal';
import {
  DirectoryRoles,
  isAbleToSeeUIElement,
} from '../../../../utils/roles/client-roles';
import { useUserSettings } from '../../../../utils/use-user-settings';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import type { SxProps, Theme } from '@mui/material/styles';

export interface GroupHealthSettingsGearProps {
  sx?: SxProps<Theme>;
}

export default function GroupHealthSettingsGear({
  sx,
}: GroupHealthSettingsGearProps) {
  const [open, setOpen] = useState(false);
  const { directoryRoles } = useUserSettings();

  const canEdit = isAbleToSeeUIElement(
    directoryRoles,
    DirectoryRoles.EditGroupHealthSettings.value
  );

  return (
    <>
      <Tooltip
        title={
          canEdit
            ? 'Health settings'
            : `You do not have the "${DirectoryRoles.EditGroupHealthSettings.name}" permission.`
        }
      >
        <span>
          <IconButton
            size="small"
            sx={sx}
            disabled={!canEdit}
            onClick={() => setOpen(true)}
            aria-label="Groups settings"
          >
            <SettingsOutlined />
          </IconButton>
        </span>
      </Tooltip>
      {canEdit && (
        <GroupHealthSettingsModal open={open} onClose={() => setOpen(false)} />
      )}
    </>
  );
}
